import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-compare-features-link',
  template: `
    <a
      href="https://hospitable.com/pricing/#feature-comparison"
      target="_blank"
      rel="noopener noreferrer"
      class="link  font-semibold">
      Compare all features
    </a>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareFeaturesLinkComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
